import { Link } from "react-router-dom";
import { codeblaze2 } from "../../../assets/image";

const LogoImage = () => {
  return (
    <div className="framer-1hv1geq" data-framer-name="Logo">
      <Link to="/" className="framer-1rc6u42 !w-[100px]" data-framer-name="Logo">
        <div
          className="absolute inset-0 rounded-inherit"
          data-framer-background-image-wrapper="true"
        >
          <img
            className="block w-full h-full rounded-inherit object-center object-contain"
            decoding="async"
            src={codeblaze2}
            alt="logo"
          />
        </div>
      </Link>
    </div>
  );
};

export default LogoImage;
